import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useQueryMemberProfileAsMember({
  api,
  memberId,
}: {
  api: ApiType;
  memberId: string | undefined;
}) {
  return useQuery({
    queryKey: memberAsMemberQueryKeys.profile(),
    queryFn: async () => (await api.profileApi.profile()).data,
    enabled: !!memberId,
  });
}
